import { LogoStore } from '~/components/LogoStore'

import * as S from './styles'

/**
 * Conteúdo do painel lateral com o motivo de rejeição de um subpublisher no
 * fluxo de aprovação de uma campanha. O título é responsabilidade de quem
 * abre o painel (via `addSidePanel({ title, content: <RejectionReasonModal /> })`).
 */
const RejectionReasonModal = ({
  publisherName,
  publisherLogo,
  reason
}: RejectionReasonModalProps) => (
  <S.Container>
    <header>
      <LogoStore alt={publisherName} linkLogo={publisherLogo} size="small" />
      <strong>{publisherName}</strong>
    </header>

    <p>{reason}</p>
  </S.Container>
)

export default RejectionReasonModal
